module.exports = ".disabled-ui{\n    opacity: .5;\n}\n.privacy-settings-wrapper .sidebar-title{\n    text-align: right;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/privacy-settings/privacy-settings.component.css
// module id = ./src/app/feature/main/roles-shared/components/privacy-settings/privacy-settings.component.css
// module chunks = main